import React, { useState, useEffect, Fragment } from 'react';
import './KickingOffTheConversation.scss';
import InteractionContainer from "../../partials/InteractionContainer/InteractionContainer";
import Button from '../../partials/Button/Button';
import BackButton from '../../partials/Button/BackButton';
import Scroll from '../../partials/Scroll/Scroll';
import Media from '../../partials/Media';

const sectionsReducer = (state, action) => {
  switch(action.type) {
      case "ACTION_SET_AS_COMPLETED":
          const sectionToMarkAsCompleted = state.find( s => {
              return  (s.id === action.payload)
          })
          if (sectionToMarkAsCompleted) {
              return [...state.slice(0,state.indexOf(sectionToMarkAsCompleted)),
                  {
                      ...sectionToMarkAsCompleted,
                      isComplete: true,
                  },
                  ...state.slice(state.indexOf(sectionToMarkAsCompleted) +1, state.length),
              ]
          }
          break
      case "ACTION_CLICKED":
          const section = state.find( s => {
              return  (s.id === action.payload.item)
          })
          // a Main section was clicked
          if (section) {
              return state.map( s => {
                      if (s.id === section.id) {
                          return {
                              ...section,
                              isExpanded: !section.isExpanded
                          }
                      }
                      if (s.isExpanded === true && action.payload.allowMultipleExpanded === false) {
                          return {
                              ...s,
                              isExpanded: false,
                          }
                      }
                      return s
              })
          }
          // A Subsection was clicked
          for (let i = 0; i < state.length; i++)   {
              let section = state[i]
              const subsection = section.sections.find( s => s.id === action.payload.item)
              if (subsection) {
                  section.sections = [
                      ...section.sections.slice(0, section.sections.indexOf(subsection)),
                      {
                          ...subsection,
                          isComplete: true,
                      },
                      ...section.sections.slice(section.sections.indexOf(subsection) +1, section.sections.length)
                  ]
                  return [...state.slice(0,state.indexOf(section)),
                      {
                          ...section
                      },
                      ...state.slice(state.indexOf(section) +1, state.length),
                  ]
              }
          }
          return state
      default:
          throw new Error(`Unknown action ${state.type}`)
  }
}

const KickingOffTheConversation = props => {

  const { data } = props;
  const { tabs } = data || {};
  if(!tabs) {
    throw new Error('No tabs on Accordion');
  }
  console.log(props);

  const [ source, setSource ] = useState(data);
  const [ currentTab, setCurrentTab ] = useState();
  const [ completion, setCompletion ] = useState(0);


  const viewInstructions = (value) => {
    let newInformation = source.information;
    newInformation.active = value;
    setSource({
      ...source,
      information: newInformation
    });

  };

  const changeTab = (tabIndex) => {
    setCurrentTab(tabIndex);
    // This is for marking the tab as readed
    let updatedTabs = source.tabs;
    updatedTabs[tabIndex].readed = true;
    setSource({
      ...source,
      tabs: updatedTabs
    });
  };

  const checkCompletion = () => {
    const steps = source.tabs.length;
    let completed = 0;

    source.tabs.forEach(( tab ) => {
      if (tab.readed) {
        completed += 1;
      }
    });
    const result = (completed / steps) * 100;
    setCompletion(result);
    console.log(result);
  }

  useEffect(() => {
    checkCompletion()
  }, [source])

  return (
    <InteractionContainer withFrame={true} breadcrumbs={props.breadcrumbs}>
      <div className="back-btn-container">
          <BackButton text={"Back"} onClick={props.goBackToPreviousSegment}/>
      </div>

      <div className="kicking-off">
        <div className='instructions'>
            <h2 dangerouslySetInnerHTML={{__html: props.data.intro.body}} />
        </div>
      {/*{ !source.information.active  ?*/}
        {true ?
        <>
          {/*<div className="instructions-tab">*/}
          {/*  <div className="icon" onClick={ () => { viewInstructions(true) } }>*/}
          {/*    <i className="fa fa-info"></i>*/}
          {/*  </div>*/}
          {/*  <div className="inst_txt" dangerouslySetInnerHTML={{ __html: source.information.instructions }}></div>*/}
          {/*</div>*/}
          <div className="accordion-container">
            {
              source.tabs.map( (tab, tabIndex) => (
                <Fragment key={`accordion-tab-${tabIndex}`}>
                  <div className={`accordion-hor ${currentTab === tabIndex ? 'active' : ''}`} onClick={ () => { changeTab(tabIndex) } }>
                    <div className={`accordion-hor-bar-blue ${tab.readed ? 'readed' : ''}`}>

                      { tab.icon !== "" &&
                        <div className="vertical-title">
                          <p>
                            {tab.verticalTitle}
                          </p>
                        </div>
                      }
                    </div>
                    {/* <Scroll> */}
                    { currentTab === tabIndex &&
                    <div className="accordion-hor-content">
                      <Scroll >
                        <div className="accordion-hor-content-scroll">
                          <div className="flex">
                            <div className="accord_left">
                              <h2>{tab.title}</h2>
                              <span dangerouslySetInnerHTML={{ __html: tab.body }}></span>
                              { tab.audios.length > 0 &&
                                tab.audios.map((audio, audioIndex) => (
                                  <div className={`audio-item`} key={`audio-item-${audioIndex}`}>
                                    <h4>{audio.instructions}</h4>
                                    <div className="audio-player">
                                      <audio controls>
                                        <source src={audio.url} type={`audio/${audio.extension}`} />
                                      </audio>
                                    </div>
                                  </div>
                                ))
                              }
                            </div>

                            <div className="accord_right">
                              <Media src={tab.images} alt={`Tab Image`} />
                            </div>
                          </div>
                        </div>
                      </Scroll>
                    </div>
                    }
                    {/* </Scroll> */}
                  </div>
                </Fragment>
              ))
            }
          </div>
        </>
        :
        <></>
        // Commented this to make run with current Editor: JR
        // <div className="information-tab">
        //   <div className="information-child">
        //     <h2>{source.information.title}</h2>
        //     <div dangerouslySetInnerHTML={{ __html: source.information.body }}></div>
        //     <button className="mt-2" onClick={() => { viewInstructions(false) }}>{source.information.buttonText}</button>
        //   </div>
        //   { source.information.image !== "" &&
        //     <div className="information-child">
        //       <img src={source.information.image} width="100%" />
        //     </div>
        //   }
        // </div>
      }
      {
        <div className="cnt_fright">
          { completion === 100 &&
            <Button 
              variant="toRight" 
              text="Next"
              onClick={() => {
                if (props.onComplete) {
                    props.onComplete()
                }
                if (props.markComplete) {
                  props.markComplete()
                }
              }}
              className={"global-button mt-2"}>
              {/* Continue */}
            </Button>
          }
        </div>
      }
    </div>
    </InteractionContainer>
  );

}

export default KickingOffTheConversation;
